var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObCustomerBehavior(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#OBCustomerBehavior_svg__clip0_8255_41704)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.449 1.84a6.667 6.667 0 115.102 12.32A6.667 6.667 0 015.45 1.84zM8 2.903a5.098 5.098 0 100 10.196A5.098 5.098 0 008 2.902z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.059 6.693a.98.98 0 01.98-.98h.008a.98.98 0 110 1.96H6.04a.98.98 0 01-.98-.98zM8.98 6.693a.98.98 0 01.98-.98h.009a.98.98 0 010 1.96H9.96a.98.98 0 01-.98-.98zM6.835 9.288h-.002v-.001l-.003-.002H6.83l.006.003zm-.006-.003l.008.004.054.028A2.63 2.63 0 008 9.569a2.63 2.63 0 001.162-.28l.008-.004a.784.784 0 01.801 1.348l-.403-.672.403.672-.002.001-.002.002-.004.002-.013.008-.037.02-.119.061a4.196 4.196 0 01-1.795.41 4.196 4.196 0 01-1.914-.47 2.28 2.28 0 01-.037-.021l-.013-.008-.004-.002-.002-.002h-.001l.402-.673-.403.672a.784.784 0 01.801-1.348z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBCustomerBehavior_svg__clip0_8255_41704"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.333 1.333)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}

export default SvgObCustomerBehavior;